import './image-hover-reveal.scss';
    
var magic = document.querySelector('.hover-reveal__sphere');
var container = document.querySelector('.hover-reveal__scene')

var magicWHalf = 500;
var magicWHalf = magicWHalf / 2;

container.addEventListener('mousemove',function(e){
  magic.style.left = e.pageX - this.offsetLeft - magicWHalf+'px';
  magic.style.top = e.pageY - this.offsetTop  - magicWHalf+'px';
});

document.body.addEventListener('mouseout',function(e){
  //magic.style.left = 'calc(50% - 10rem)';
  //magic.style.top = 'calc(50% - 10rem)';
});